/**
 * Full Image Storytelling component.
 * @module components/media
 */
import { _extends } from 'brei-project-utils';

const storytelling = {

	elem: {
		$buttons: $('.storytelling__image'),
		$slider: $('.storytelling__list')
	},

	options: {
		adaptiveHeight: true,
		dots: false,
		draggable: true,
		fade: true,
		infinite: true,
		responsive: [],
		rows: 0,
		slidesToScroll: 1,
		slidesToShow: 1,
		speed: 500,
		prevArrow: '<button class="storytelling__prev btn btn--small"><span class="show-for-sr">Go to the previous slide</span><svg class="brei-icon brei-icon-chevron"><use xmlns:xlink="http://www.w3.org/1999/xlink" href="#brei-icon-chevron"></use></svg></button>',
		nextArrow: '<button class="storytelling__next btn btn--small"><span class="show-for-sr">Go to the next slide</span><svg class="brei-icon brei-icon-chevron"><use xmlns:xlink="http://www.w3.org/1999/xlink" href="#brei-icon-chevron"></use></svg></button>'
	},

	init() {
		if (this.elem.$slider.length > 0) {
			this.activateSliders();
			if (this.elem.$buttons.length > 0) {
				this.elem.$buttons.on('click', this.onClick.bind(this));
			}
		}

	},

	activateSliders() {		
		const _this = this;

		this.elem.$slider.each(function () {
			if($(this).children().length) {
				console.log('heyo');
				let prev = $(this).parent().find('.js-prev');
				let next = $(this).parent().find('.js-next');
				let gallery = $(this).parent().find('.storytelling__gallery');
				
				let options = _extends({}, _this.options);
				
				if (prev.length > 0) {
					options.prevArrow = prev;
				}

				if (next.length > 0) {
					options.nextArrow = next;
				}

				if (gallery.length > 0) {
					let cards = gallery.find('.storytelling__image');
					if(cards.length < 2) {
						console.log(cards.eq(0));
						cards.eq(0).attr('disabled','disabled');
					}
					$(this).on('beforeChange', function(event, slick, currentSlide, nextSlide) {
						let cards = $(event.target).parents('.storytelling').find('.storytelling__image');
						console.log('flugar');
						let currentClass = cards[currentSlide].classList[1];
						let nextClass = cards[nextSlide].classList[1];
						cards[currentSlide].classList.add(nextClass);
						cards[currentSlide].classList.remove(currentClass);
						cards[nextSlide].classList.add(currentClass);
						cards[nextSlide].classList.remove(nextClass);
					}).slick(options);
				} else {
					$(this).slick(options);
				}
			}
		});
	},

	onClick(e) {
		let slider = $(e.target).parents('.storytelling').find('.storytelling__list')
		let currentSlide = slider.slick('slickCurrentSlide');
		let newSlide = storytelling.elem.$buttons.index(e.target);
		if((currentSlide !== undefined) && (currentSlide !== newSlide) && (newSlide > -1)) {
			slider.slick('slickGoTo', newSlide);
		};
	}

};

export { storytelling};

// to use:
//
// import media from './modules/media';
//
// media.init();
